export const toE164 = (dialCode: string, localNumber: string): string => {
  const nationalDigits = localNumber.replace(/\D/g, '').replace(/^0+/, '');
  return `${dialCode}${nationalDigits}`;
};
